import { render, staticRenderFns } from "./productBox.vue?vue&type=template&id=0fbb1af8&scoped=true"
import script from "./productBox.vue?vue&type=script&lang=js"
export * from "./productBox.vue?vue&type=script&lang=js"
import style0 from "./productBox.vue?vue&type=style&index=0&id=0fbb1af8&prod&lang=scss&scoped=true"
import style1 from "./productBox.vue?vue&type=style&index=1&id=0fbb1af8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbb1af8",
  null
  
)

export default component.exports